/* Scroll-Story — Drei-Rail-Design
   Portiert 1:1 aus snapshots/v3-sand-stone/src/components/ScrollStory.astro

   RAIL 1 · TEXT (State-Machine, zeitbasiert)
     Jede Szene hat ein Active-Fenster im Scroll-Progress.
     CSS-Transition macht den Fade in 500 ms, sequentiell.

   RAIL 2 · VIDEO (Plateau-basiert, Spring-Physik k=22 d=8)
     Während eine Szene aktiv ist: Video HÄLT auf ihrem Frame.
     Zwischen Plateaus: smootherstep-Interpolation.
     Spring-Smoother integriert kontinuierlich → echte Trägheit.

   RAIL 3 · STORY-RAIL (5 Dots rechts)
     Zeigt die aktuelle Szene. Klick → smooth scroll. */

(function () {
  var SCENES = [
    { start: 0.00, end: 0.14 },
    { start: 0.17, end: 0.32 },
    { start: 0.35, end: 0.50 },
    { start: 0.53, end: 0.68 },
    { start: 0.71, end: 0.84 }
  ];

  var VIDEO_PLATEAUS = [
    { hold: [0.03, 0.10], frame: 0.05 },
    { hold: [0.21, 0.28], frame: 0.26 },
    { hold: [0.39, 0.46], frame: 0.48 },
    { hold: [0.57, 0.64], frame: 0.72 },
    { hold: [0.75, 1.00], frame: 0.95 }
  ];

  function smoothstepSoft(t) {
    return t * t * t * (t * (t * 6 - 15) + 10);
  }

  function scrollToVideoRatio(p) {
    if (p <= VIDEO_PLATEAUS[0].hold[0]) return VIDEO_PLATEAUS[0].frame;
    var last = VIDEO_PLATEAUS[VIDEO_PLATEAUS.length - 1];
    if (p >= last.hold[1]) return last.frame;
    for (var i = 0; i < VIDEO_PLATEAUS.length; i++) {
      var plat = VIDEO_PLATEAUS[i];
      if (p >= plat.hold[0] && p <= plat.hold[1]) return plat.frame;
    }
    for (var j = 0; j < VIDEO_PLATEAUS.length - 1; j++) {
      var a = VIDEO_PLATEAUS[j];
      var b = VIDEO_PLATEAUS[j + 1];
      if (p > a.hold[1] && p < b.hold[0]) {
        var t = (p - a.hold[1]) / (b.hold[0] - a.hold[1]);
        return a.frame + (b.frame - a.frame) * smoothstepSoft(t);
      }
    }
    return last.frame;
  }

  var FADE_MS = 500;
  var GAP_MS = 80;

  function clamp01(n) {
    return Math.max(0, Math.min(1, n));
  }

  function setup() {
    var container = document.querySelector('[data-scroll-story]');
    if (!container) return;
    var video = container.querySelector('[data-story-video]');
    var scenes = Array.prototype.slice.call(container.querySelectorAll('.scene'));
    var loader = container.querySelector('[data-story-loader]');
    var loaderBar = container.querySelector('[data-loader-bar]');
    var scrollHint = container.querySelector('[data-scroll-hint]');
    if (!video || scenes.length === 0) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      scenes.forEach(function (s) {
        s.style.opacity = '1';
        s.style.transform = 'none';
      });
      if (loader) loader.classList.add('is-ready');
      return;
    }

    if (scrollHint) {
      var idleTimer = window.setTimeout(function () {
        scrollHint.removeAttribute('hidden');
        requestAnimationFrame(function () { scrollHint.classList.add('is-visible'); });
      }, 2800);
      window.addEventListener('scroll', function () {
        if (idleTimer !== null) { clearTimeout(idleTimer); idleTimer = null; }
        scrollHint.classList.remove('is-visible');
      }, { once: true, passive: true });
    }

    function computeProgress() {
      var rect = container.getBoundingClientRect();
      var total = container.offsetHeight - window.innerHeight;
      if (total <= 0) return 0;
      return clamp01(Math.max(0, -rect.top) / total);
    }

    function findDesired(p, current) {
      for (var i = 0; i < SCENES.length; i++) {
        if (p >= SCENES[i].start && p <= SCENES[i].end) return i;
      }
      if (current !== -1) return current;
      var nearest = 0;
      var best = Infinity;
      for (var k = 0; k < SCENES.length; k++) {
        var mid = (SCENES[k].start + SCENES[k].end) / 2;
        var d = Math.abs(p - mid);
        if (d < best) { best = d; nearest = k; }
      }
      return nearest;
    }

    var currentActive = -1;
    var desiredActive = -1;
    var busy = false;

    function stepTransition() {
      if (busy) return;
      if (currentActive === desiredActive) return;
      busy = true;
      if (currentActive !== -1) {
        var leaving = scenes[currentActive];
        leaving.classList.remove('is-active');
        currentActive = -1;
        window.setTimeout(function () {
          busy = false;
          stepTransition();
        }, FADE_MS + GAP_MS);
        return;
      }
      if (desiredActive !== -1) {
        var entering = scenes[desiredActive];
        entering.classList.add('is-active');
        currentActive = desiredActive;
        window.setTimeout(function () {
          busy = false;
          stepTransition();
        }, FADE_MS);
      } else {
        busy = false;
      }
    }

    var railDots = Array.prototype.slice.call(container.querySelectorAll('[data-rail-dot]'));
    function setRailActive(idx) {
      railDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }
    function scrollToScene(idx) {
      var scene = SCENES[idx];
      var mid = (scene.start + scene.end) / 2;
      var total = container.offsetHeight - window.innerHeight;
      var containerTop = container.getBoundingClientRect().top + window.scrollY;
      var targetY = containerTop + total * mid;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }
    railDots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { scrollToScene(idx); });
    });

    function updateTextTarget() {
      var p = computeProgress();
      var want = findDesired(p, desiredActive);
      if (want !== desiredActive) {
        desiredActive = want;
        setRailActive(want);
        stepTransition();
      }
    }

    /* Spring-Physik — Feder-Masse mit Dämpfung.
       SPRING_K=22, SPRING_D=8 (knapp unter kritisch 2√K ≈ 9.4).
       Sanfter Drift am Ende, kein sichtbares Überschwingen. */
    var SEEK_EPS = 1 / 60;
    var SPRING_K = 22;
    var SPRING_D = 8;
    var JUMP_THRESHOLD = 0.5;
    var renderedVideoTime = 0;
    var videoVelocity = 0;
    var lastVideoTime = -1;
    var lastFrameTime = 0;
    var videoRaf = 0;

    function videoStep(now) {
      var dtMs = lastFrameTime ? Math.min(64, now - lastFrameTime) : 16;
      lastFrameTime = now;
      var dt = dtMs / 1000;

      if (video.duration && !isNaN(video.duration)) {
        var target = scrollToVideoRatio(computeProgress()) * video.duration;
        var gap = target - renderedVideoTime;
        var jumpCutoff = video.duration * JUMP_THRESHOLD;

        if (Math.abs(gap) > jumpCutoff) {
          renderedVideoTime = target;
          videoVelocity = 0;
        } else {
          var force = gap * SPRING_K;
          videoVelocity += force * dt;
          videoVelocity -= videoVelocity * SPRING_D * dt;
          renderedVideoTime += videoVelocity * dt;
          if (renderedVideoTime < 0) { renderedVideoTime = 0; videoVelocity = 0; }
          else if (renderedVideoTime > video.duration) { renderedVideoTime = video.duration; videoVelocity = 0; }
        }

        if (Math.abs(renderedVideoTime - lastVideoTime) > SEEK_EPS) {
          try { video.currentTime = renderedVideoTime; } catch (e) {}
          lastVideoTime = renderedVideoTime;
        }

        if (Math.abs(target - renderedVideoTime) > 0.001 || Math.abs(videoVelocity) > 0.02) {
          videoRaf = requestAnimationFrame(videoStep);
          return;
        }
        videoVelocity = 0;
      }
      videoRaf = 0;
      lastFrameTime = 0;
    }

    function scheduleVideo() {
      if (!videoRaf) videoRaf = requestAnimationFrame(videoStep);
    }

    video.addEventListener('play', function () { try { video.pause(); } catch (e) {} });

    video.addEventListener('progress', function () {
      if (!loaderBar || !video.buffered.length || !video.duration) return;
      var buffered = video.buffered.end(video.buffered.length - 1);
      loaderBar.style.width = (buffered / video.duration * 100) + '%';
    });

    function onReady() {
      if (loader) loader.classList.add('is-ready');
      try { video.pause(); video.currentTime = 0; } catch (e) {}
      if (video.duration) {
        renderedVideoTime = scrollToVideoRatio(computeProgress()) * video.duration;
        try { video.currentTime = renderedVideoTime; } catch (e2) {}
        lastVideoTime = renderedVideoTime;
      }
      desiredActive = findDesired(computeProgress(), -1);
      setRailActive(desiredActive);
      stepTransition();
      scheduleVideo();
    }

    var _readyFired = false;
    function tryReady() {
      if (_readyFired) return;
      _readyFired = true;
      onReady();
    }
    try { video.load(); } catch (e) {}
    if (video.readyState >= 2) tryReady();
    else {
      video.addEventListener('loadeddata', tryReady, { once: true });
      video.addEventListener('loadedmetadata', tryReady, { once: true });
      video.addEventListener('canplay', tryReady, { once: true });
      window.setTimeout(tryReady, 1500);
    }

    function onScroll() {
      updateTextTarget();
      scheduleVideo();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
